<hr class="mt-2 mb-2" />
<div class="alert alert-warning py-2 px-3 mb-1 d-flex align-items-center">
  <strong>&#9888;&nbsp;Itens com Pendência (Reserva)</strong>
  <span class="ml-2 text-muted" style="font-size:0.9em;">
    — quantidade solicitada excede o estoque. Ao salvar, será criado um pedido pendência separado para o faltante.
  </span>
</div>
<div class="table-responsive">
  <table class="table table-sm table-bordered">
    <thead class="thead-light">
      <tr>
        <th>Código</th>
        <th>Produto</th>
        <th class="text-center">Qtde Solicitada</th>
        <th class="text-center">Estoque</th>
        <th class="text-center text-warning">Faltante (Pendência)</th>
      </tr>
    </thead>
    <tbody>
      @for (p of produtosAdicionados; track p) {
        <tr>
          @if (p.qtde > 0 && p.estoque != null && p.qtde > p.estoque && !(p.produtos_vinculados?.length > 0)) {
            <td>{{ p.codigo }}</td>
            <td>{{ p.name }}</td>
            <td class="text-center">{{ p.qtde }}</td>
            <td class="text-center">{{ p.estoque }}</td>
            <td class="text-center font-weight-bold text-warning">{{ p.qtde - p.estoque }}</td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
